import { Observable } from 'rxjs';
import { ResumenResponse } from '../interfaces/resumen-response';


export abstract class ResumenService {

    abstract getResumen(): Observable<ResumenResponse>;
}
